module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "sec-18"
    }
  }, [_c('h1', {
    staticClass: "chapter",
    attrs: {
      "id": "pAnU"
    }
  }, [_vm._v("\n\t\t\t\t\tBIBLICAL CHANGE AMONG CHURCHES OF CHRIST ")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "pAqx"
    }
  }, [_c('b', [_vm._v("\n\t\t\t\t\tRichard Hughes")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "pz18-2"
    }
  }, [_vm._v("\n\t\t\t\t\tWithout intending to be so, this book is a tribute to D’Esta Love and the twenty-eight\n\t\t\t\t\tother women whose sermons grace these pages. It is a tribute to them because, by\n\t\t\t\t\tpersisting in their careful reading of the biblical text, they learned that the gospel\n\t\t\t\t\tis inclusive, not exclusive. It is a tribute to them because they refused to bow\n\t\t\t\t\tto entrenched attempts to segregate the church by gender. And it is a tribute to\n\t\t\t\t\tthem because of their courage, for in pulpits of Churches of Christ across this land\n\t\t\t\t\tand beyond they have shared with their brothers and sisters the glorious gospel message,\n\t\t\t\t\toften against overwhelming odds. And now they have shared these sermons with us,\n\t\t\t\t\ttheir readers. ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz18-3"
    }
  }, [_vm._v("\n\t\t\t\t\tThis book is also a tribute to the Church of Christ and the commitment of its people\n\t\t\t\t\tto the biblical text. From the earliest days of our movement in the nineteenth century,\n\t\t\t\t\twe have always said that we are committed to no ideology or theory about the Bible,\n\t\t\t\t\tbut to the biblical text itself. In 1830, for example, the Church of Christ at Concord,\n\t\t\t\t\tKentucky, issued a statement that summarizes a conviction that has characterized\n\t\t\t\t\tChurches of Christ from that day to this: “The "), _c('i', [_vm._v("fatal error")]), _vm._v(" of all reformers,” that\n\t\t\t\t\tchurch announced, “has been that they have too hastily concluded "), _c('i', [_vm._v("that they knew the\n\t\t\t\t\twhole truth")]), _vm._v(". . . . We have no reason to conclude, we know all the truth. . . . We\n\t\t\t\t\thave nothing to lose in this inquiry after truth. We have no system to bind us to\n\t\t\t\t\thuman opinion.” ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz18-4"
    }
  }, [_vm._v("\n\t\t\t\t\tAnd that is the spirit that has encouraged many in Churches of Christ to rethink\n\t\t\t\t\twhat the Bible teaches about the role of women in the public worship of the church.\n\t\t\t\t\t")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz18-5"
    }
  }, [_vm._v("\n\t\t\t\t\tWhen I served as the editor of "), _c('i', [_vm._v("Mission Journal")]), _vm._v(" in the late 1970s, I received a handwritten\n\t\t\t\t\tletter from a woman lamenting the fact that neither "), _c('span', {
    attrs: {
      "id": "z19-1"
    }
  }, [_vm._v("she nor any of the other women\n\t\t\t\t\tin her congregation were permitted to make any meaningful contributions to the teaching\n\t\t\t\t\tor the public worship of that church. They could not lead in pubic prayer. They could\n\t\t\t\t\tnot serve communion. They could not read Scripture aloud. They could not preach.\n\t\t\t\t\tAnd they could not teach others publicly when men—even boys—were present. ")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz19-2"
    }
  }, [_vm._v("\n\t\t\t\t\tShe grieved all the more since she knew that she was far better equipped to teach\n\t\t\t\t\tthe Bible than were many of the men in that congregation. None of the men—including\n\t\t\t\t\tthe elders—had gone to college and some had not finished high school. But they were\n\t\t\t\t\tmen and were therefore privileged above the women to teach the truths of the Christian\n\t\t\t\t\tfaith, qualified mostly by their gender. ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz19-3"
    }
  }, [_vm._v("\n\t\t\t\t\tOn the other hand, this woman held a college degree and, with the tools she had acquired\n\t\t\t\t\tin college, had spent years studying the biblical text. She was fully equipped to\n\t\t\t\t\tteach, even to preach. But she could not speak a word of instruction or admonition\n\t\t\t\t\tin the public worship simply because of her gender. ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz19-4"
    }
  }, [_vm._v("\n\t\t\t\t\tThis woman’s letter to me was neither bitter nor strident, but it was forceful and\n\t\t\t\t\tdid not mince words. I assumed she was a younger woman whose perspectives had been\n\t\t\t\t\tshaped, in part, by the spirit of gender equality so prevalent at that time. ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz19-5"
    }
  }, [_vm._v("\n\t\t\t\t\tBut then, after several paragraphs explaining the reasons for her discouragement,\n\t\t\t\t\tall penned in a beautiful hand, wild marks suddenly appeared on the paper. The marks\n\t\t\t\t\twent up and down and across and diagonally with no rhyme or reason. I thought, "), _c('i', [_vm._v("This\n\t\t\t\t\twoman has become so angry that she has lost her senses in a fit of rage.")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz19-6"
    }
  }, [_vm._v("\n\t\t\t\t\tBut when I turned the letter over, I made a startling discovery: “Please accept my\n\t\t\t\t\tapology,” she wrote, “on behalf of my grandchild who marked up my letter with crayons\n\t\t\t\t\twhen I was out of the room.” ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz19-7"
    }
  }, [_vm._v("\n\t\t\t\t\tAnd then I knew. This was not a young woman at all, but an older woman—a grandmother,\n\t\t\t\t\tin fact—who had been struggling with the silence imposed on her for decades. And\n\t\t\t\t\tthe story she told symbolized the plight of thousands upon thousands of women in\n\t\t\t\t\tChurches of Christ, many with enormous gifts in biblical teaching and understanding,\n\t\t\t\t\twhose voices "), _c('span', {
    attrs: {
      "id": "z20-1"
    }
  }, [_vm._v("have been similarly muted over some two hundred years of the history\n\t\t\t\t\tof our tradition. ")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pAq8"
    }
  }, [_vm._v("\n\t\t\t\t\tWhile this woman wrote to lament the fact that her voice had been silenced, there\n\t\t\t\t\thave been other women in Churches of Christ who have silenced their own voices. These\n\t\t\t\t\twomen have firmly believed that Scripture requires their silence in the assembly\n\t\t\t\t\tof the church when men are present. ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pAd_"
    }
  }, [_vm._v("\n\t\t\t\t\tThe New Testament scholar David Balch grew up on a farm outside of Pampa, Texas,\n\t\t\t\t\tin the 1940s and 1950s. His parents—Elmer and Claudine Balch—were in many ways pillars\n\t\t\t\t\tof the Church of Christ in that community. His mother, he told me, was the sister\n\t\t\t\t\tof a noted chemistry professor in a Church of Christ-related college. “She was a\n\t\t\t\t\tbrilliant woman,” he said. "), _c('a', {
    attrs: {
      "id": "pAYF"
    }
  }, [_vm._v("\n\t\t\t\t\t“Her mind was as good as [her brother’s].” And then, with pathos in his voice and\n\t\t\t\t\tobvious pain in his heart, he recalled, “She never said a word in church her whole\n\t\t\t\t\tninety years.” ")])]), _c('a', {
    attrs: {
      "id": "pAYF"
    }
  }), _c('p', {
    attrs: {
      "id": "pz20-4"
    }
  }, [_c('a', {
    attrs: {
      "id": "pAYF"
    }
  }, [_vm._v("\n\t\t\t\t\tHis mother’s silence impacted David so profoundly that, as a doctoral student in\n\t\t\t\t\tNew Testament studies at Yale, he focused much of his academic work on what the Bible\n\t\t\t\t\tactually taught regarding the role of women in the worship of the assembled church.\n\t\t\t\t\tIn pursuing this topic, David was an authentic child of Churches of Christ, seeking\n\t\t\t\t\tto understand the biblical text ever more clearly. And when he determined—at least\n\t\t\t\t\tto his own satisfaction—that Churches of Christ had misconstrued the Bible’s teaching\n\t\t\t\t\ton that topic, he sought to convince his mother, but to no avail. David carries the\n\t\t\t\t\tburden of her silence to this day."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#pz22-10",
      "id": "pz22-10a"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz20-5"
    }
  }, [_vm._v("\n\t\t\t\t\tBut a happier story emerges from the Church of Christ in Midlothian, Texas. As most\n\t\t\t\t\treaders of this book will undoubtedly know, Jack and LeMoine Lewis (Jack at the Harding\n\t\t\t\t\tSchool of Theology and LeMoine at Abilene Christian University) have inspired scores\n\t\t\t\t\tof men—and, indeed, some women—to take up the mantle of scholarship in biblical and\n\t\t\t\t\trelated studies. And those individuals have, in turn, inspired literally hundreds\n\t\t\t\t\tof men—and, indeed, some women—to respond to the call of ministry in a local church.\n\t\t\t\t\tAnd LeMoine, by directing the Bible Teachers Workshop at ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "pz20-6"
    }
  }, [_vm._v("\n\t\t\t\t\tAbilene Christian from 1959 to 1966, inspired hundreds, perhaps thousands, "), _c('span', {
    attrs: {
      "id": "z21-1"
    }
  }, [_vm._v("of dedicated\n\t\t\t\t\tChristian men and women to become better teachers of the biblical text. ")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz21-2"
    }
  }, [_vm._v("\n\t\t\t\t\tLeMoine and Jack grew up in the Church of Christ in Midlothian, a small farming community\n\t\t\t\t\tabout thirty miles south of Dallas and Fort Worth. In an interview with Jack, he\n\t\t\t\t\ttold me that people with education—any level of education at all—were few and far\n\t\t\t\t\tbetween in that congregation."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#pz22-11",
      "id": "pz22-11a"
    }
  }, [_vm._v("2")])]), _vm._v(" But according to LeMoine’s daughter, Claudia Lewis\n\t\t\t\t\tRandolph, ")]), _vm._v(" "), _c('blockquote', {
    attrs: {
      "id": "pz21-3"
    }
  }, [_c('p', {
    staticClass: "p"
  }, [_vm._v("\n\t\t\t\t\t\tThere was one person in Midlothian who had done much in the way of education—the\n\t\t\t\t\t\ttown librarian who held a master’s degree. Dad, when discussing the role of women,\n\t\t\t\t\t\twould point back to the Midlothian church. The librarian, a woman, taught the adult\n\t\t\t\t\t\tBible class when he was growing up. The elders’ explanation to any who complained\n\t\t\t\t\t\twas, “She isn’t usurping authority. We asked her to teach. She is by far the most\n\t\t\t\t\t\tqualified.” ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "pz21-4"
    }
  }, [_vm._v("\n\t\t\t\t\tClaudia concluded, “Scholarship may be tended, watered, and fertilized at a university\n\t\t\t\t\tsuch as ACU, but most of the time the seeds were planted in some church by some Bible\n\t\t\t\t\tschool teacher or some elder who took the time to learn and then teach the word.”\n\t\t\t\t\tAnd then she said, “I think if my Dad were . . . asked about scholarship, he would\n\t\t\t\t\tpoint back to the local church, its elders and its Bible school teachers,” and especially\n\t\t\t\t\tperhaps to the woman who taught the adults when Jack and LeMoine grew up in Midlothian,\n\t\t\t\t\tTexas."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#pz22-12",
      "id": "pz22-12a"
    }
  }, [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz21-5"
    }
  }, [_vm._v("\n\t\t\t\t\tBased on that story, we are left to speculate on whether there might have been a\n\t\t\t\t\tLeMoine Lewis or a Jack Lewis had it not been for the woman who was their first serious\n\t\t\t\t\tteacher of the biblical text. And given the pervasive influence Jack and LeMoine\n\t\t\t\t\texerted on scholarship and ministry in Churches of Christ, that question, in turn,\n\t\t\t\t\tleads us to wonder if there would have been an Abraham Malherbe, an Everett Ferguson,\n\t\t\t\t\ta Kathy Pulley, a D’Esta Love, a Robert M. Randolph, or a host of other great preachers\n\t\t\t\t\tand teachers of the biblical text had it not been for this talented and godly woman\n\t\t\t\t\twho first inspired both Jack and LeMoine in Bible classes at the "), _c('span', {
    attrs: {
      "id": "z22-1"
    }
  }, [_vm._v("Church of Christ\n\t\t\t\t\tin the small farming community of Midlothian, Texas, so many years ago. ")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz22-2"
    }
  }, [_vm._v("\n\t\t\t\t\tNone of these stories, of course, have any bearing on the long-standing discussion\n\t\t\t\t\twithin Churches of Christ regarding the role of women in the public worship of the\n\t\t\t\t\tchurch and especially in the pulpit. To resolve that debate, we have always turned—and\n\t\t\t\t\tI trust will always turn—to the biblical text. ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz22-3"
    }
  }, [_vm._v("\n\t\t\t\t\tBut one thing is certain—the women whose sermons appear in this book compel us to\n\t\t\t\t\tstand with that church in Concord, Kentucky, whose members affirmed almost two hundred\n\t\t\t\t\tyears ago, “We have nothing to lose in this inquiry after truth. We have no system\n\t\t\t\t\tto bind us to human opinion.” And they compel us to explore again the meaning of\n\t\t\t\t\tthat great biblical principle upon which the work of these women must finally rest:\n\t\t\t\t\t")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "pz22-4"
    }
  }, [_vm._v("\n\t\t\t\t\t“There is neither Jew nor Greek, there is neither slave nor free, there is neither\n\t\t\t\t\tmale nor female; for you are all one in Christ Jesus.” ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0",
      "margin-bottom": "1em"
    },
    attrs: {
      "id": "pz22-6"
    }
  }, [_c('b', [_vm._v("Jan Hughes")]), _vm._v(" is a writer and speaker and for eight years co-taught with her husband,\n\t\t\t\t\tRichard, an honors first-year seminar at Messiah College on the theme, “Learning\n\t\t\t\t\tto Tell Our Stories” ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "pz22-7"
    }
  }, [_c('b', [_vm._v("Richard Hughes")]), _vm._v(" is Distinguished Professor of Religion Emeritus at both Pepperdine\n\t\t\t\t\tUniversity and Messiah College ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "center",
    staticStyle: {
      "font-size": "1.1em"
    },
    attrs: {
      "id": "pz22-9"
    }
  }, [_vm._v("\n\t\t\t\t\tNotes ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz22-10"
    }
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/#pz22-10a"
    }
  }, [_vm._v("1")])]), _vm._v("David Balch, interview with Richard Hughes, Pacific Lutheran Theological Seminary,\n\t\t\t\t\t\tBerkeley, California, March 28, 2014. ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz22-11"
    }
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/#pz22-11a"
    }
  }, [_vm._v("2")])]), _vm._v("Jack Lewis, interview with Richard Hughes, Memphis, Tennessee, February 10, 2014.\n\t\t\t\t\t\t")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz22-12"
    }
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/#pz22-12a"
    }
  }, [_vm._v("3")])]), _vm._v("Claudia Lewis Randolph, letter to Richard Hughes, January 26, 2015. ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-baaaf0e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter01.vue
// module id = 84
// module chunks = 0